import { Injectable, NgModule } from '@angular/core';
import { DataApiService, BaseService } from '@xpo-ltl/data-api';
import { ConfigManagerService, CONFIG_MANAGER_SERVICE_CONFIGURATION, ConfigManagerModule } from '@xpo-ltl/config-manager';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@xpo-ltl/data-api';
import * as ɵngcc2 from '@xpo-ltl/config-manager';
class InfrastructureApiService extends BaseService {
    /**
     * @param {?} dataApiService
     * @param {?} configManager
     */
    constructor(dataApiService, configManager) {
        super();
        this.dataApiService = dataApiService;
        this.configManager = configManager;
    }
    /**
     * Health check URL. Responds with success message if the service is running.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    healthCheck(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/health-check'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * List of resources.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    options(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/options'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * Details of user invoking the API.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    loggedInUser(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/appusers/logged-in-user'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation returns the distance, in miles or kilometers, between an origin and destination using the Rand McNally API. If the optional routeType is not supplied, then routeType defaults to 'H'.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid origin and destination must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then a response code of 200 and the distance will be returned.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getDistanceBetweenLocations(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/locations/from/{origin}/to/{destination}/distance'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation lists printers.
     * <br/>
     * <br/>Pre-condition:
     * <br/>None
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the list of printers will be returned.
     * <br/>2. Otherwise an appropriate error message will be returned.
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listPrinters(queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/printers'), {
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation prints documents.
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. A valid email address is passed in the 'to' list.
     * <br/>2. The message subject and text are provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then an email message will be sent to the email address mentioned in the 'to' list.
     * <br/>2. Otherwise an appropriate error message will be returned.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    printDocuments(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/printers/documents'), {
            formData: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation sends an email message.
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. A valid email address is passed in the 'to' list.
     * <br/>2. The message subject and text are provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then an email message will be sent to the email address mentioned in the 'to' list.
     * <br/>2. Otherwise an appropriate error message will be returned.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    sendEmail(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/messages/email'), {
            formData: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation wraps the Twilio text message API in order to send a text message to the recipient phone number.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid to phone number and message are provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the text message is sent to the recipient phone number.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    sendTextMessage(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/messages/texts'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation creates an Email Template.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid Email Template is provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then a status code of 200 along with the created Email Template will be returned.
     * <br/>2. Otherwise an appropriate error message will be returned.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    createEmailTemplate(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/messages/emails/templates'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation deletes an Email Template.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid emailTemplateId is provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then a status code of 200 will be returned.
     * <br/>2. Otherwise an appropriate error message will be returned.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    deleteEmailTemplate(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/messages/emails/templates/{emailTemplateId}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.delete(apiRequest);
    }
    /**
     * This operation lists Email Templates.
     * <br/>
     * <br/>Pre-condition:
     * <br/>None
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then a status code of 200 along with the list of Email Templates will be returned.
     * <br/>2. Otherwise an appropriate error message will be returned.
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listEmailTemplates(queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/messages/emails/templates'), {
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation updates an Email Template.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid emailTemplateId and Email Template data are provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then a status code of 200 along with the created Email Template will be returned.
     * <br/>2. Otherwise an appropriate error message will be returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    updateEmailTemplate(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/messages/emails/templates/{emailTemplateId}'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation creates a printer configuration.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. Valid PrinterConfig details are provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the printer configuration is created and the associated printer ID is returned.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    createPrinterConfig(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/printers/configs'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation lists printer configurations.
     * <br/>
     * <br/>Pre-condition:
     * <br/>None
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the printer configurations are listed.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listPrinterConfigs(queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/printers/configs'), {
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation updates a printer configuration.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. Valid PrinterConfig details are provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the printer configuration is updated and the associated printer ID is returned.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    updatePrinterConfig(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/printers/configs'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * @return {?}
     */
    getEndPoint() {
        return this.configManager.getSetting(InfrastructureApiService.InfrastructureApiEndpoint);
    }
}
InfrastructureApiService.ɵfac = function InfrastructureApiService_Factory(t) { return new (t || InfrastructureApiService)(ɵngcc0.ɵɵinject(ɵngcc1.DataApiService), ɵngcc0.ɵɵinject(ɵngcc2.ConfigManagerService)); };
InfrastructureApiService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: InfrastructureApiService, factory: InfrastructureApiService.ɵfac });
InfrastructureApiService.InfrastructureApiEndpoint = 'infrastructureV2ApiEndpoint';
/** @nocollapse */
InfrastructureApiService.ctorParameters = () => [
    { type: DataApiService },
    { type: ConfigManagerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InfrastructureApiService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.DataApiService }, { type: ɵngcc2.ConfigManagerService }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
const ɵ0 = { configFileUrl: './assets/config.json' };
class SdkInfrastructureModule {
}
SdkInfrastructureModule.ɵfac = function SdkInfrastructureModule_Factory(t) { return new (t || SdkInfrastructureModule)(); };
SdkInfrastructureModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SdkInfrastructureModule });
SdkInfrastructureModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        InfrastructureApiService,
        { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: ɵ0 },
    ], imports: [[
            ConfigManagerModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SdkInfrastructureModule, [{
        type: NgModule,
        args: [{
                imports: [
                    ConfigManagerModule
                ],
                providers: [
                    InfrastructureApiService,
                    { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: ɵ0 },
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SdkInfrastructureModule, { imports: function () { return [ConfigManagerModule]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Infrastructure API
 * Version: 2.0
 * Build: 2.0.0.11
 */
/**
 * Details about a printer.
 */
class Printer {
    constructor() {
        /**
         * The name of the printer.
         * Required: false
         * Array: false
         */
        this.name = undefined;
        /**
         * The service center identification code for the printer.
         * Required: false
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The sources of the printer's paper.
         * Required: false
         * Array: true
         */
        this.paperSources = undefined;
    }
}
/**
 * The information that is used for sending text messages.
 */
class TextMessage {
    constructor() {
        /**
         * The phone number of the sender of the message.
         * Required: false
         * Array: false
         */
        this.fromPhoneNbr = undefined;
        /**
         * The phone number of the recipient of the message.
         * Required: false
         * Array: false
         */
        this.toPhoneNbr = undefined;
        /**
         * The message for the text.
         * Required: false
         * Array: false
         */
        this.messageText = undefined;
    }
}
/**
 * Stores templates that will be used to generate emails for different types of requirements.  Added 04/13/2021  LISG-11256
 */
class EmailTemplate {
    constructor() {
        /**
         * Unique identifier of template
         * Required: false
         * Array: false
         */
        this.emailTemplateId = undefined;
        /**
         * Three character component code (PRC, INV, OPS, etc.)
         * Required: false
         * Array: false
         */
        this.componentCd = undefined;
        /**
         * A component can have as many different email templates as it needs.
         * Required: false
         * Array: false
         */
        this.typeCd = undefined;
        /**
         * List of to email addresses
         * Required: false
         * Array: false
         */
        this.toRecipient = undefined;
        /**
         * List of cc email addresses
         * Required: false
         * Array: false
         */
        this.ccRecipient = undefined;
        /**
         * Subject of Email
         * Required: false
         * Array: false
         */
        this.subject = undefined;
        /**
         * Content of email
         * Required: false
         * Array: false
         */
        this.body = undefined;
        /**
         * Link to DMS documents
         * Required: false
         * Array: false
         */
        this.attachment = undefined;
        /**
         * Audit
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * Additional email lines for a template. If the text of the message is too long, the first part is stored in GLB_EMAIL_TEMPLATE, and the remaining text is broken in multiple lines as needed and recorded here with seq_nbr.  Added 04/13/2021  LISG-11256
 */
class EmailTemplateExtended {
    constructor() {
        /**
         * Unique identifier of template
         * Required: false
         * Array: false
         */
        this.emailTemplateId = undefined;
        /**
         * Part of Unique identifier of Extended row.
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         * Content of email
         * Required: false
         * Array: false
         */
        this.body = undefined;
        /**
         * Audit
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * Holds printer info per SIC for laser printers.  Added 04/18/2022  LISG-16632
 */
class PrinterConfig {
    constructor() {
        /**
         * UNique id of the Printer
         * Required: false
         * Array: false
         */
        this.printerId = undefined;
        /**
         * Identifier of the Service Center where printer is located
         * Required: false
         * Array: false
         */
        this.sicCode = undefined;
        /**
         * For legacy printer name purposes
         * Required: false
         * Array: false
         */
        this.alias = undefined;
        /**
         * Name of tray 1
         * Required: false
         * Array: false
         */
        this.tray1 = undefined;
        /**
         * Name of Tray 2 - if applicable
         * Required: false
         * Array: false
         */
        this.tray2 = undefined;
        /**
         * Name of Tray 3 - if applicable
         * Required: false
         * Array: false
         */
        this.tray3 = undefined;
        /**
         * Audit
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
class GetDistanceBetweenLocationsPath {
    constructor() {
        /**
         * The origin of the route. The origin can be one of the following:
         * 1. City and state
         * 2. City, country qualifier, and state
         * 3. Latitude and longitude
         * 4. ZIP code
         * 5. 3-digit ZIP code prefix
         * Required: true
         * Array: false
         */
        this.origin = undefined;
        /**
         * The destination of the route. The destination can be one of the following:
         * 1. City and state
         * 2. City, county qualifier, and state
         * 3. Latitude and longitude
         * 4. ZIP code
         * 5. 3-digit ZIP code prefix
         * Required: true
         * Array: false
         */
        this.destination = undefined;
    }
}
class GetDistanceBetweenLocationsQuery {
    constructor() {
        /**
         * The type of route. The value can be either 'H' or 'P'.
         * Required: false
         * Array: false
         */
        this.routeType = undefined;
        /**
         * The length of the truck. The value can be either '48' or '53'.
         * Required: false
         * Array: false
         */
        this.truckLengthNbr = undefined;
        /**
         * Indicates whether the route is hazmat. The value can be either '0' (off) or '1' (on).
         * Required: false
         * Array: false
         */
        this.hazmatInd = undefined;
        /**
         * Indicates whether the distance is returned in kilometers. The value can be '0' (off) or '1' (on).
         * Required: false
         * Array: false
         */
        this.kmInd = undefined;
        /**
         * Indicates whether tolls should be avoided on the route. The values can be either '0' (off) or '1' (on).
         * Required: false
         * Array: false
         */
        this.avoidTollsInd = undefined;
    }
}
class GetDistanceBetweenLocationsResp {
    constructor() {
        /**
         * The status of the response. The value can be either 'SUCESS' if the response succeeded or 'FAILURE' if the response failed.
         * Required: false
         * Array: false
         */
        this.status = undefined;
        /**
         * The distance in miles or kilometers between the requested origin and destination.
         * Required: false
         * Array: false
         */
        this.distance = undefined;
    }
}
/**
 * Query parameter which is used to list printers.
 */
class ListPrintersQuery {
    constructor() {
        /**
         * The list of service center identification codes.
         * Required: false
         * Array: true
         */
        this.sicCds = undefined;
    }
}
/**
 * Response to the request to list printers.
 */
class ListPrintersResp {
    constructor() {
        /**
         * Details for the list of printers associated with the name provided.
         * Required: false
         * Array: true
         */
        this.printers = undefined;
    }
}
/**
 * Request to print documents.
 */
class PrintDocumentsRqst {
    constructor() {
        /**
         * The name of the printer to which the documents will be sent for printing.
         * Required: true
         * Array: false
         */
        this.printerName = undefined;
        /**
         * The documents that will be printed.
         * Required: true
         * Array: true
         */
        this.documents = undefined;
        /**
         * The sources of the printer's paper.
         * Required: false
         * Array: true
         */
        this.paperSources = undefined;
    }
}
/**
 * Request to send an email.
 */
class SendEmailRqst {
    constructor() {
        /**
         * The bcc'd list of recipients' email addresses which are separated by a semicolon.
         * Required: false
         * Array: false
         */
        this.bcc = undefined;
        /**
         * The cc'd list of recipients' email addresses which are separated by a semicolon.
         * Required: false
         * Array: false
         */
        this.cc = undefined;
        /**
         * The sender's email address.
         * Required: false
         * Array: false
         */
        this.from = undefined;
        /**
         * The name of the sender of the message.
         * Required: false
         * Array: false
         */
        this.fromName = undefined;
        /**
         * The body of the email message.
         * Required: true
         * Array: false
         */
        this.messageBody = undefined;
        /**
         * The priority of the message: Low, Medium, or High.
         * Required: false
         * Array: false
         */
        this.priority = undefined;
        /**
         * The subject of the email message.
         * Required: true
         * Array: false
         */
        this.subject = undefined;
        /**
         * The recipients' email addresses which are separated by a semicolon.
         * Required: true
         * Array: false
         */
        this.to = undefined;
        /**
         * The files that will be attached to the email.
         * Required: false
         * Array: true
         */
        this.files = undefined;
    }
}
/**
 *
 */
class SendTextMessageRqst {
    constructor() {
        /**
         * The information about the text message that will be sent to a recipient.
         * Required: true
         * Array: false
         */
        this.textMessage = undefined;
    }
}
/**
 * Request to create an Email Template.
 */
class CreateEmailTemplateRqst {
    constructor() {
        /**
         * >The email template that will be created.
         * Required: true
         * Array: false
         */
        this.emailTemplate = undefined;
    }
}
/**
 * Response to the request to create an Email Template.
 */
class CreateEmailTemplateResp {
    constructor() {
        /**
         * The email template that was created.
         * Required: false
         * Array: false
         */
        this.emailTemplate = undefined;
    }
}
/**
 * The path parameter which is used to delete an Email Template.
 */
class DeleteEmailTemplatePath {
    constructor() {
        /**
         * The unique identifier of the Email Template.
         * Required: true
         * Array: false
         */
        this.emailTemplateId = undefined;
    }
}
/**
 * The query parameters which are used to list Email Templates.
 */
class ListEmailTemplatesQuery {
    constructor() {
        /**
         * The three-character code associated with the component for the templates.
         * Required: false
         * Array: false
         */
        this.componentCd = undefined;
        /**
         * The list of codes associated with the types of templates.
         * Required: false
         * Array: true
         */
        this.typeCds = undefined;
    }
}
/**
 * Response to the request to list Email Templates.
 */
class ListEmailTemplatesResp {
    constructor() {
        /**
         * The list of email templates that matched the filter criteria.
         * Required: false
         * Array: true
         */
        this.emailTemplates = undefined;
    }
}
/**
 * The path parameter which is used to update an Email Template.
 */
class UpdateEmailTemplatePath {
    constructor() {
        /**
         * The unique identifier of the email template.
         * Required: true
         * Array: false
         */
        this.emailTemplateId = undefined;
    }
}
/**
 * Request to update an Email Template.
 */
class UpdateEmailTemplateRqst {
    constructor() {
        /**
         * The email template that will be updated.
         * Required: true
         * Array: false
         */
        this.emailTemplate = undefined;
    }
}
/**
 * Response to the request to update an Email Template.
 */
class UpdateEmailTemplateResp {
    constructor() {
        /**
         * The email template that was updated.
         * Required: false
         * Array: false
         */
        this.emailTemplate = undefined;
    }
}
/**
 *
 */
class CreatePrinterConfigRqst {
    constructor() {
        /**
         * The PrinterConfig details which will be used to perform the creation.
         * Required: true
         * Array: false
         */
        this.printerConfig = undefined;
    }
}
/**
 *
 */
class CreatePrinterConfigResp {
    constructor() {
        /**
         * The unique identifier of the printer.
         * Required: false
         * Array: false
         */
        this.printerId = undefined;
    }
}
/**
 *
 */
class ListPrinterConfigsResp {
    constructor() {
        /**
         * The list of printer configs.
         * Required: false
         * Array: true
         */
        this.printerConfigs = undefined;
    }
}
/**
 *
 */
class ListPrinterConfigsQuery {
    constructor() {
        /**
         * The service center identification code.
         * Required: false
         * Array: false
         */
        this.sicCd = undefined;
    }
}
/**
 *
 */
class UpdatePrinterConfigRqst {
    constructor() {
        /**
         * The PrinterConfig details which will be used to perform the update.
         * Required: true
         * Array: false
         */
        this.printerConfig = undefined;
    }
}
/**
 *
 */
class UpdatePrinterConfigResp {
    constructor() {
        /**
         * The unique identifier of the printer.
         * Required: false
         * Array: false
         */
        this.printerId = undefined;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { SdkInfrastructureModule, InfrastructureApiService, Printer, TextMessage, EmailTemplate, EmailTemplateExtended, PrinterConfig, GetDistanceBetweenLocationsPath, GetDistanceBetweenLocationsQuery, GetDistanceBetweenLocationsResp, ListPrintersQuery, ListPrintersResp, PrintDocumentsRqst, SendEmailRqst, SendTextMessageRqst, CreateEmailTemplateRqst, CreateEmailTemplateResp, DeleteEmailTemplatePath, ListEmailTemplatesQuery, ListEmailTemplatesResp, UpdateEmailTemplatePath, UpdateEmailTemplateRqst, UpdateEmailTemplateResp, CreatePrinterConfigRqst, CreatePrinterConfigResp, ListPrinterConfigsResp, ListPrinterConfigsQuery, UpdatePrinterConfigRqst, UpdatePrinterConfigResp };

